import { QuoteCountStatusRequest } from "@/main/models/request/quoteRequest";
import { CartResponseCount } from "@/main/models/response";

export enum CartCountStatusTypes {
	GET_CART_COUNT_STATUS = "@cartCountStatus/GET_CART_COUNT_STATUS",
	SAVE_CART_COUNT_STATUS = "@cartCountStatus/SAVE_CART_COUNT_STATUS",
	RESET_REDUCER_CART_COUNT_STATUS = "@cartCountStatus/RESET_REDUCER_CART_COUNT_STATUS",
}

export interface CartCountStatusState {
	readonly cartCountStatus: {
		data: CartResponseCount[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetCartCountStatus {
	type: typeof CartCountStatusTypes.GET_CART_COUNT_STATUS;
	payload: {
		request: QuoteCountStatusRequest;
	};
}

export interface SaveCartCountStatus {
	type: typeof CartCountStatusTypes.SAVE_CART_COUNT_STATUS;
	payload: {
		data: CartResponseCount[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerCartCountStatus {
	type: typeof CartCountStatusTypes.RESET_REDUCER_CART_COUNT_STATUS;
}

export type CartCountStatusActionTypes = GetCartCountStatus | SaveCartCountStatus | ResetReducerCartCountStatus;
